import React from 'react'
import Currency from '../Currency'

const TotalBox = ({ amount }) => {
  return (
    <div className="flex justify-between font-bold">
      <span>Total:</span>
      <span>
        <Currency amount={amount} />
      </span>
    </div>
  )
}

export default TotalBox
